<template>
  <div class="section container">
    <div class="section-header">
      <div class="section-title">
        <div class="section-icon section-icon-address" :class="brandClass()"></div>
        <h3 class="section-title-label">
          {{$t("profile_personal_data_address_summary_title")}}
        </h3>
        <div class="section-subtitle-label">
          {{$t("profile_personal_data_address_summary_subtitle")}}
        </div>
      </div> 
    </div>
    <div v-if="userAddresses() && userAddresses().length" class="infos addresses-information">
      <div class="info-container address-container" :class="{'display_none':address.delete, 'opaque':(editMode!=null && editMode!=index) }"  v-for="(address, index) in userAddresses()"
        :key="`address-${index}`">
        <div v-if="!address.delete" class="info address">
          <div style="display: flex; flex-direction: column">
            <div :style="{order:0}" class="label address-label">{{statusLabel(address.addressStatus)}}</div>
            <div :style="{order:getFieldOrder('street', address.country)}" class="value address-value" v-if="isUserAddressDataToDisplay(address, 'street')">{{displayUserAddressData(address, 'street')}}</div>
            <div :style="{order:getFieldOrder('houseNumber', address.country)}" class="value address-value" v-if="isUserAddressDataToDisplay(address, 'houseNumber')">{{displayUserAddressData(address, 'houseNumber')}}</div>
            <div :style="{order:getFieldOrder('strSuppl1', address.country)}" class="value address-value" v-if="isUserAddressDataToDisplay(address, 'strSuppl1')" >{{displayUserAddressData(address, 'strSuppl1')}}</div>
            <div :style="{order:getFieldOrder('strSuppl2', address.country)}" class="value address-value" v-if="isUserAddressDataToDisplay(address, 'strSuppl2')" >{{displayUserAddressData(address, 'strSuppl2')}}</div>
            <div :style="{order:getFieldOrder('postalCode', address.country)}" class="value address-value" v-if="isUserAddressDataToDisplay(address, 'postalCode')" >{{displayUserAddressData(address, 'postalCode')}}</div>
            <div :style="{order:getFieldOrder('city', address.country)}" class="value address-value" v-if="isUserAddressDataToDisplay(address, 'city')" >{{displayUserAddressData(address, 'city')}}</div>
            <div :style="{order:getFieldOrder('regionCode', address.country)}" class="value address-value" v-if="isUserAddressDataToDisplay(address, 'regionCode')" >{{displayUserAddressData(address, 'regionCode')}}</div>
            <div :style="{order:getFieldOrder('country', address.country)}" class="value address-value" v-if="isUserAddressDataToDisplay(address, 'country')" >{{displayUserAddressData(address, 'country')}}</div>
            <div :style="{order:getFieldOrder('companyName', address.country)}" v-if="address.addressStatus=='BUSINESS' && isUserAddressDataToDisplay(address, 'companyName')" class="value address-value" >{{displayUserAddressData(address, 'companyName')}}</div>
          </div>        
          <div class="dashboardContainer" :class="{'hidden': editMode==index || editMode==-1}">
            <div @keydown="ariaClick" role="button" tabindex="0" :aria-label="$t('profile_edit_button')" class="edit" :class="{'pointer': editMode==null, 'hidden': editDisabled}"  @click="editMode==null && handleEditMode(index)"></div><span class="buttonLabel" :class="{'pointer': editMode==null, 'hidden': editDisabled}" @click="editMode==null && handleEditMode(index)">{{$t('profile_edit_button')}}</span>
          </div>
          <div class="dashboardContainer" :class="{'hidden': editMode==index || editMode==-1}">
            <div @keydown="ariaClick" role="button" tabindex="0" :aria-label="$t('profile_delete_button')" class="delete" :class="{'pointer': editMode==null, 'hidden': editDisabled}" @click="editMode==null && openPopup(index)"></div><span class="buttonLabel" :class="{'pointer': editMode==null, 'hidden': editDisabled}" @click="editMode==null && openPopup(index)">{{$t('profile_personal_data_address_summary_remove_button')}}</span>
          </div>
          <div v-if="address.preferred" class="value address-value">{{$t('profile_personal_data_address_summary_preferred_address')}}</div>
        </div>
      </div>
    </div>
    <div  id="add" class="add pointer" :class="{'hidden': editMode!=null || editDisabled}" @click="handleEditMode(-1)">
      <div @keydown="ariaClick" role="button" tabindex="0" class="add-icon" :class="brandClass()" :aria-label="$t('profile_personal_data_address_summary_add_address')" @click="handleEditMode(-1)"></div>
      <div class="add-label">
        {{$t("profile_personal_data_address_summary_add_address")}}
      </div>
    </div>
    <form v-if="editMode!=null" novalidate class="form" @submit.prevent="validateAddress">
      <div class="form_flex_container">
        <div style="order:0; width:100%" class="address_type_radio_container">
          <div v-for="(status, index) in this.$c('list_of_addressStatus')" :key="`address_type-${index}`"  class="address_type_radio">
            <div @keydown="ariaClick" role="button" tabindex="0" @click="handleAddressType(status.typeKey)" class="radio" :class="v$.form.type.$model==status.typeKey && 'selected'"></div><div class="radio_label">{{$t(status.translationKey)}}</div>
          </div>
        </div>
        <div id="address-form-input">
          <!-- HOUSE NUMBER -->
          <div class="custom-field" 
            :style="{ order: getFieldFormOrder('houseNumber') }">
            <OneInput
              :brandClass="brandClass()"
              :profileStyle="true"
              v-model.trim="form.houseNumber" 
              :form="v$.form"     
              :label="$t('profile_personal_data_add_or_edit_address_houseNumber_label')+(isRequired('houseNumber') ? '*' : '')" 
              :paramName="'houseNumber'"
              :id="'houseNumber'"
              @blur="touchForm('houseNumber')"
              :errors="[
                {message:$t('profile_personal_data_add_or_edit_address_houseNumber_error_required'), thereIsTheError:v$.form.houseNumber.required.$invalid},
                {message:$t('profile_error_min_length_prefix')+getMinLength('houseNumber')+$t('profile_error_min_length_suffix'), thereIsTheError:v$.form.houseNumber.minLength.$invalid},
                {message:$t('profile_error_max_length_prefix')+getMaxLength('houseNumber')+$t('profile_error_max_length_suffix'), thereIsTheError:v$.form.houseNumber.maxLength.$invalid},
              ]"
            />
          </div>
          <!-- STREET -->
          <div class="custom-field" 
            :style="{ order: getFieldFormOrder('street') }">
            <OneInput
              :brandClass="brandClass()"
              :profileStyle="true"
              v-model.trim="form.street" 
              :form="v$.form"     
              :label="$t('profile_personal_data_add_or_edit_address_street')+(isRequired('street') ? '*' : '')" 
              :paramName="'street'"
              :id="'street'"
              @blur="touchForm('street')"
              :errors="[
                {message:$t('profile_personal_data_add_or_edit_address_street_error_required'), thereIsTheError:v$.form.street.required.$invalid},
                {message:$t('profile_error_min_length_prefix')+getMinLength('street')+$t('profile_error_min_length_suffix'), thereIsTheError:v$.form.street.minLength.$invalid},
                {message:$t('profile_error_max_length_prefix')+getMaxLength('street')+$t('profile_error_max_length_suffix'), thereIsTheError:v$.form.street.maxLength.$invalid},
              ]"
            />
          </div>
          <!-- ADDITIONAL LINE 1 -->
          <div class="custom-field" 
            :style="{ order: getFieldFormOrder('strSuppl1') }">
            <OneInput
              :brandClass="brandClass()"
              :profileStyle="true"
              v-model.trim="form.strSuppl1" 
              :form="v$.form"     
              :label="$t('profile_personal_data_add_or_edit_address_strSuppl1')+(isRequired('strSuppl1') ? '*' : '')" 
              :paramName="'strSuppl1'"
              :id="'strSuppl1'"
              @blur="touchForm('strSuppl1')"
              :errors="[
                {message:$t('profile_error_min_length_prefix')+getMinLength('strSuppl1')+$t('profile_error_min_length_suffix'), thereIsTheError:v$.form.strSuppl1.minLength.$invalid},
                {message:$t('profile_error_max_length_prefix')+getMaxLength('strSuppl1')+$t('profile_error_max_length_suffix'), thereIsTheError:v$.form.strSuppl1.maxLength.$invalid},
              ]"
            />
          </div>
          <!-- ADDITIONAL LINE 2 -->
          <div class="custom-field" 
            :style="{ order: getFieldFormOrder('strSuppl2') }">
            <OneInput
              :brandClass="brandClass()"
              :profileStyle="true"
              v-model.trim="form.strSuppl2" 
              :form="v$.form"     
              :label="$t('profile_personal_data_add_or_edit_address_strSuppl2')+(isRequired('strSuppl2') ? '*' : '')" 
              :paramName="'strSuppl2'"
              :id="'strSuppl2'"
              @blur="touchForm('strSuppl2')"
              :errors="[
                {message:$t('profile_error_min_length_prefix')+getMinLength('strSuppl2')+$t('profile_error_min_length_suffix'), thereIsTheError:v$.form.strSuppl2.minLength.$invalid},
                {message:$t('profile_error_max_length_prefix')+getMaxLength('strSuppl2')+$t('profile_error_max_length_suffix'), thereIsTheError:v$.form.strSuppl2.maxLength.$invalid},
              ]"
            />
          </div>
          <!-- POSTAL CODE -->
          <div class="custom-field" 
            :style="{ order: getFieldFormOrder('postalCode') }">
            <OneInput
              :brandClass="brandClass()"
              :profileStyle="true"
              v-model.trim="form.postalCode" 
              :form="v$.form"     
              :label="$t('profile_personal_data_add_or_edit_address_postalCode')+(isRequired('postalCode') || form.street ? '*' : '')" 
              :paramName="'postalCode'"
              :id="'postalCode'"
              @blur="touchForm('postalCode')"
              :errors="[
                {message:$t('profile_personal_data_add_or_edit_address_postalCode_error_required'), thereIsTheError:v$.form.postalCode.required.$invalid},
                {message:$t('profile_error_min_length_prefix')+getMinLength('postalCode')+$t('profile_error_min_length_suffix'), thereIsTheError:v$.form.postalCode.minLength.$invalid},
                {message:$t('profile_error_max_length_prefix')+getMaxLength('postalCode')+$t('profile_error_max_length_suffix'), thereIsTheError:v$.form.postalCode.maxLength.$invalid},
              ]"
            />
          </div>
          <!-- CITY -->
          <div class="custom-field" 
            :style="{ order: getFieldFormOrder('city') }">
            <OneInput
              :brandClass="brandClass()"
              :profileStyle="true"
              v-model.trim="form.city" 
              :form="v$.form"     
              :label="$t('profile_personal_data_add_or_edit_address_city')+(isRequired('city') ? '*' : '')" 
              :paramName="'city'"
              :id="'city'"
              @blur="touchForm('city')"
              :errors="[
                {message:$t('profile_personal_data_add_or_edit_address_houseNumber_error_required'), thereIsTheError:v$.form.city.required.$invalid},
                {message:$t('profile_error_min_length_prefix')+getMinLength('city')+$t('profile_error_min_length_suffix'), thereIsTheError:v$.form.city.minLength.$invalid},
                {message:$t('profile_error_max_length_prefix')+getMaxLength('city')+$t('profile_error_max_length_suffix'), thereIsTheError:v$.form.city.maxLength.$invalid},
              ]"
            />
          </div>
          <!-- REGION CODE -->
          <div
            v-if="isRegionCodeVisible(form.country)"
            class="custom-field" 
            :style="{ order: getFieldFormOrder('regionCode') }">
            <OneInput
              :brandClass="brandClass()"
              :profileStyle="true"
              v-model.trim="form.regionCode" 
              :form="v$.form"     
              :label="$t('profile_personal_data_add_or_edit_address_regionCode')+(isRequired('regionCode') ? '*' : '')" 
              :paramName="'regionCode'"
              :id="'regionCode'"
              @blur="touchForm('regionCode')"
              :errors="[
                {message:$t('profile_personal_data_add_or_edit_address_houseNumber_error_required'), thereIsTheError:v$.form.regionCode.required.$invalid},
                {message:$t('profile_error_min_length_prefix')+getMinLength('regionCode')+$t('profile_error_min_length_suffix'), thereIsTheError:v$.form.regionCode.minLength.$invalid},
                {message:$t('profile_error_max_length_prefix')+getMaxLength('regionCode')+$t('profile_error_max_length_suffix'), thereIsTheError:v$.form.regionCode.maxLength.$invalid},
              ]"
            />
          </div>
          <!-- COUNTRY -->
          <div class="custom-field" :style="{ order: getFieldFormOrder('country') }">
            <OneSelect
              :brandClass="brandClass()"
              :t="$t"
              :profileStyle="true"
              v-model="form.country"
              :form="v$.form"  
              :paramName="'country'"
              :disabled="thereAreNoCountries"
              :options="selectedOptions"
              @blur="touchForm('country')"
              :isSearchEnabled="true"
              :label="$t('profile_personal_data_add_or_edit_address_country')+(isRequired('country') ? '*' : '')"
              :errors="[
                {message:$t('profile_personal_data_add_or_edit_address_error_required'), thereIsTheError:v$.form.country.required.$invalid}
              ]"
            ></OneSelect>
          </div>
          <!-- COMPANY NAME -->
          <div class="custom-field" 
            v-if="v$.form.type.$model=='BUSINESS'"
            :style="{ order: getFieldFormOrder('companyName') }">
            <OneInput
              :brandClass="brandClass()"
              :profileStyle="true"
              v-model.trim="form.companyName" 
              :form="v$.form"     
              :label="$t('profile_personal_data_add_or_edit_address_companyName')+(isRequired('companyName') ? '*' : '')" 
              :paramName="'companyName'"
              :id="'companyName'"
              @blur="touchForm('companyName')"
              :errors="[
                {message:$t('profile_personal_data_add_or_edit_address_houseNumber_error_required'), thereIsTheError:v$.form.companyName.required.$invalid},
                {message:$t('profile_error_min_length_prefix')+getMinLength('companyName')+$t('profile_error_min_length_suffix'), thereIsTheError:v$.form.companyName.minLength.$invalid},
                {message:$t('profile_error_max_length_prefix')+getMaxLength('companyName')+$t('profile_error_max_length_suffix'), thereIsTheError:v$.form.companyName.maxLength.$invalid},
              ]"
            />
          </div>
        </div>
        <div class="mandatory" style="order:100">*{{$t("generic_mandatory_fields")}}</div>
        <div class="custom-field" 
                      style="order:100; display: flex; margin-top: 20px">
          <OneCheckbox
            :brandClass="brandClass()"
            :id="`preferred`"
            v-model="form.preferred"
            :required="false"
            :paramName="`preferred`"
          >
            <template v-slot:labelcontent>
              <span class="checkbox-label" :class="brandClass()" for="preferred">
                {{$t("profile_personal_data_add_or_edit_address_preferred")}}
              </span>
            </template>
          </OneCheckbox>
        </div>

        <div class="buttonsContainer" style="order:100; width:100%" >
          <OneButton
            :brandClass="brandClass()"
            :profileStyle="true"
            :type="'primary'"
            :label="editMode==-1 ? $t('profile_personal_data_add_or_edit_address_insert_button') : $t('profile_apply_button')"
            :disabled="isButtonDisabled"
            @click="validateAddress()"
          />
          <OneButton
            :brandClass="brandClass()"
            :profileStyle="true"
            :type="'secondary'"
            :label="$t('profile_cancel_button')"
            @click="cancelClicked(null)"
          />
        </div>
      </div>
    </form>
    <OneAlert
      :brandClass="brandClass()"
      v-if="showPopup"
      :title="$t('profile_personal_data_delete_address_title')"
      :content="$t('profile_personal_data_delete_address_subtitle')"
      :button_confirm_label="$t('profile_delete_button')"
      :button_cancel_label="$t('profile_personal_data_delete_address_cancel_button')"
      @confirm="remove"
      @close="closePopup"
    >
    </OneAlert>
    <OneAlert
      :brandClass="brandClass()"
      v-if="isSuggestedAddressModalVisible"
      :title="$t('profile_personal_data_address_suggest_title')"
      :content="$t('profile_personal_data_address_suggest_subtitle')"
      :button_confirm_label="$t('profile_personal_data_address_suggest_apply_button')"
      :button_cancel_label="''"
      :button_big_label="''"
      @confirm="addressSuggestionManagement(true)"
      :showCloseButton="false"
    >
      <template v-slot:internal-content>
        <div class="info-container address-container">
          <div class="address-title">{{$t('profile_personal_data_address_suggest_label')}}</div>
          <div class="info address">
            <div class="value address-value">{{suggestedAddress.street}} {{suggestedAddress.houseNumber}}</div>
            <div class="value address-value">{{suggestedAddress.strSuppl1}}</div>
            <div class="value address-value">{{suggestedAddress.strSuppl2}}</div>
            <div class="value address-value">{{suggestedAddress.postalCode}}</div>
            <div class="value address-value">{{suggestedAddress.city}}</div>
            <div v-if="isRegionCodeVisible(suggestedAddress.country)" class="value address-value">{{suggestedAddress.regionCode}}</div>
            <div class="value address-value">{{countryLabel(suggestedAddress.country)}}</div>
          </div>
        </div>
      </template>
      <template v-slot:external-content>
        <div class="discard-label" :class="brandClass()">
          <span @keydown="ariaClick" role="button" tabindex="0" @click="addressSuggestionManagement(false)">{{$t('profile_personal_data_address_suggest_discard_button')}}</span>
        </div> 
      </template>
    </OneAlert>
    
  </div>
</template>
<style lang="scss" scoped>

  #address-form-input {
    width: 100%;
    display: flex; 
    flex-direction: column;
    .custom-field {
      margin: 0 0 9px;
    }
  }
  .radio_label{
    margin: 0 32px;
    line-height: 24px;
    display: inline-block;
  }
  .section-icon-address {
      background-image: url('~@/assets/default/light/address-default-light.svg');
      &.__d{
          background-image: url('~@/assets/default/dark/address-default-dark.svg');
      }
      &.__m {
        background-image: url('~@/assets/mini/light/address-mini-light.svg');
        &.__d{
            background-image: url('~@/assets/mini/dark/address-mini-dark.svg');
        }
    }
  }
    .address_type_radio_container{
      margin-bottom: 22px;
    }
    .checkbox__mark{
      margin-top: 10px;
    }
    .checkbox-label{
      font-size: 16px;
      margin-left: 15px;
      line-height: 24px;
      &.__m{
        line-height: 27px;
        font-size: 18px;
        font-weight: 400;
        font-family: MINISansSerif;
      }
      &.__t{
        line-height: inherit;
        font-family: ToyotaSemibold;
      }
      &.__alphabet{
        font-size: 16px;
        font-weight: 500;
        font-family: AlphabetSansPro-Medium;
          color: $alphabetblue;
      }
    }

  .discard-label {
    background-image: url('~@/assets/default/light/arrow-default-light.svg');
    font-weight: bold;
    background-repeat: no-repeat;
    padding-left: 15px;
    margin-top: 25px;
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
    &.__d{
      background-image: url('~@/assets/default/dark/arrow-default-dark.svg');
    }
    &.__m{
      background-image: url('~@/assets/mini/light/arrow-mini-light.svg');
      &:hover {
        text-decoration: none;
      }
      &.__d{
        background-image: url('~@/assets/mini/dark/arrow-mini-dark.svg');
      }
      span{
        margin-left: 12px;
        font-size: 14px;
        line-height: 13px;
        font-weight: normal;
        font-family: MINISansSerif;
        border-bottom: 1px solid $dusty;
        &:hover {
          font-weight: bold;
        }
      }
    }
    &.__t{
       &:hover {
        text-decoration: none;
      }
      span{
        margin-left: 12px;
        font-size: 14px;
        line-height: 13px;
        font-weight: normal;
        font-family: ToyotaSemibold;
        border-bottom: 1px solid $dusty;
        &:hover{
          border-bottom: 1px solid $toyotared;
        } 
        
      } 
    }
  }
</style>
<script>
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import useVuelidate from '@vuelidate/core';
import { defineComponent } from 'vue';
import {
  required, requiredIf
} from "@vuelidate/validators";
import { defineAsyncComponent } from 'vue'

export default defineComponent({
  inject:['$c', '$t', 'brandClass'],
  setup() {
    return { v$: useVuelidate() }
  },
  name: "ProfileAddressesNoFSM",
  //validations from vuelidate
  mixins: [oneUtils.customValidationMixin,oneUtils.accessibilityMixin],
  props: {
    user: {},
    editDisabled: {
      default: false,
      type: Boolean,
    },
  },
  components:{
    OneCheckbox: defineAsyncComponent(() =>
      import('../../../../gcdm-one-library/gcdm-one-checkbox/src/OneCheckbox')
    )
  },
  updated(){
    this.$emit('isEditMode', {subSection:'PA', value:this.editMode!=null});
  },
  data: () => ({
    form: {
      type: null,
      street: null,
      houseNumber: null,
      postalCode: null,
      city: null,
      country: null,
      preferred: null,
      strSuppl1: null,
      strSuppl2: null,
      regionCode: null,
      companyName: null
    },
    typeIndex: null,
    // countryIndex: null,
    // showSelect: false,
    editMode: null,
    showPopup: false,
    indexToRemove: -1,
    suggestedAddress: {},
    isSuggestedAddressModalVisible: false,
  }),
  //vuelidate custom validations
  validations: {
    form: {
      type: {
        required,
      },
      street: {
        minLength: function(value) {
          return this.isMinLengthValid('street', value);
        },
        maxLength: function(value) {
          return this.isMaxLengthValid('street', value);
        },
        required: requiredIf(function (model) {
          return this.isRequired('street');
        }),
      },
      houseNumber: {
        minLength: function(value) {
          return this.isMinLengthValid('houseNumber', value);
        },
        maxLength: function(value) {
          return this.isMaxLengthValid('houseNumber', value);
        },
        required: requiredIf(function (model) {
          return this.isRequired('houseNumber');
        }),
      },
      postalCode: {
        minLength: function(value) {
          return this.isMinLengthValid('postalCode', value);
        },
        maxLength: function(value) {
          return this.isMaxLengthValid('postalCode', value);
        },
        required: requiredIf(function (model) {
          return this.isRequired('postalCode') || this.form.street;
        }),
      },
      city: {
        minLength: function(value) {
          return this.isMinLengthValid('city', value);
        },
        maxLength: function(value) {
          return this.isMaxLengthValid('city', value);
        },
        required: requiredIf(function (model) {
          return this.isRequired('city');
        }),
      },
      country: {
        required: requiredIf(function (model) {
          return this.isRequired('country');
        }),
      },
      preferred: {},
      strSuppl1: {
        minLength: function(value) {
          return this.isMinLengthValid('strSuppl1', value);
        },
        maxLength: function(value) {
          return this.isMaxLengthValid('strSuppl1', value);
        },
        required: requiredIf(function (model) {
          return this.isRequired('strSuppl1');
        }),
      },
      strSuppl2: {
        minLength: function(value) {
          return this.isMinLengthValid('strSuppl2', value);
        },
        maxLength: function(value) {
          return this.isMaxLengthValid('strSuppl2', value);
        },
        required: requiredIf(function (model) {
          return this.isRequired('strSuppl2');
        }),
      },
      companyName: {
        minLength: function (value) {
          return this.isMinLengthValid('companyName', value);
        },
        maxLength: function (value) {
          return this.isMaxLengthValid('companyName', value);
        },
        required: requiredIf(function (model) {
          return this.isRequired('companyName');
        }),
      },
      regionCode: {
        minLength: function (value) {
          return this.isMinLengthValid('regionCode', value);
        },
        maxLength: function (value) {
          return this.isMaxLengthValid('regionCode', value);
        },
        required: requiredIf(function (model) {
          if(this.isRegionCodeVisible(this.form.country)) {
            return this.isRequired('regionCode');
          }

          return false;
        }),
      },
    },
  },
  computed: {
    isCountryRequired: function(){
      return !this.isRequired('country') ? {
                    label: '',
                    value: '',
                  }
                : null;
    },
    selectedOptions: function(){
      return this.getSelectOptions('list_of_countries');
    },
    thereAreNoCountries: function(){
      return this.selectedOptions.length === 0;
    },
    sectionConfig(){
      return this.$c('_profileConfiguration').addressesSection;
    },
    isButtonDisabled: function () {
      return (
        this.v$.$invalid
      );
    },
    typeValues() {
      return this.$c("list_of_addressStatus").map(({ translationKey }) => this.$t(translationKey));
    },
    typeKeys() {
      return this.$c("list_of_addressStatus").map(({ typeKey }) => typeKey);
    },
  },
  methods: {
    isRegionCodeVisible(country) {
      return !this.sectionConfig.addressesSectionByCountrySelection?.[country]?.hide_region_code;
    },
    getFieldOrder(fieldName, country) {
      if (this.sectionConfig.addressesSectionByCountrySelection &&
        this.sectionConfig.addressesSectionByCountrySelection[country] && 
        this.sectionConfig.addressesSectionByCountrySelection[country][fieldName]) {
          return this.getCountrySpecificOrder(fieldName, "addressesSectionByCountrySelection", country);
      }
      return this.getOrder(fieldName);
    },
    getFieldFormOrder(fieldName) {
      if (this.form.country &&
        this.sectionConfig.addressesSectionByCountrySelection &&
        this.sectionConfig.addressesSectionByCountrySelection[this.form.country] && 
        this.sectionConfig.addressesSectionByCountrySelection[this.form.country][fieldName]) {
          return this.getCountrySpecificFormOrder(fieldName, "addressesSectionByCountrySelection", this.form.country);
      }
      return this.getFormOrder(fieldName);
    },
    /**
     * Get the typekey status of address
     */
    handleAddressType(key) {
      this.form.type = key;
    },
    /**
     * Tracy tracking for add address cancelled and edit management
     */
    cancelClicked(){
      this.handleEditMode(null);
    },
    /**
     * Edit address management 
     */
    handleEditMode(key) {
      this.editMode = key;
      if (this.editMode !== null && this.editMode !== -1) {
        this.prefillForm(key);
      } else {
        this.form = {
          type: this.typeKeys[0],
          street: null,
          houseNumber: null,
          postalCode: null,
          city: null,
          country: null,
          preferred: false,
          strSuppl1: null,
          strSuppl2: null,
          regionCode: null,
        };
        this.v$.$reset();

        // prefill country based on parameters - start
        const countryToFind = this.$store.state.configurationParams.country;
        const country = this.selectedOptions.find(c => c.value === countryToFind);
        this.form.country = country && country.value;
        this.touchForm("country");
        // prefill country based on parameters - end
      }
      if (this.editMode !== null) {
        setTimeout(() => {
          this.sortAddressInputs();
          
        }, 100);
      }
    },
    /**
     *  Sorting the address and scroll to the add section
     */
    sortAddressInputs(){
      const el = document.querySelector('#address-form-input');
      if(el && el.children){
        const list = Array.prototype.slice.call(el.children, 0);
        if(list[0] && list[0].parentNode){
          const father = list[0].parentNode;
          list.sort((a,b)=>{
            const first = Number(a.style?.order);
            const second = Number(b.style?.order);
            if (first<second) {
              return -1;
            }
            if (first>second) {
              return 1;
            }
            return 0;
          });
          this.sortInDom(list, father);
        }
      }
      // const element = this.$refs['add'];
      const element = document.getElementById('add');
      if(element){
        element.scrollIntoView({behavior: "smooth", block: "start"});
      }
    },
    /**
     *  Sorting list's element and adding to the DOM
     */
    sortInDom(list, father){
      for (const elem of list) {
        elem.remove();
      }
      for (const elem of list) {
        father.appendChild(elem)
      }
    },
    /**
     *  Return lis of countrues key
     */
    countryLabel(key) {
      return this.getSelectLabelByValue("list_of_countries", key);
    },
    /**
     *  Return lis of address status key
     */
    statusLabel(key) {
      return this.getSelectLabelByValue("list_of_addressStatus", key);
    },
    /**
     *  Return user's addresses if exists
     */
    userAddresses: function () {
      return this.user.addresses || [];
    },
    /**
     *  Hide delete address popup and call the submitUpdate function
     */
    remove: function () {
      this.showPopup = false;
      this.submitUpdate();
    },
    /**
     *  Get the index of address to remove and show the address remove popup
     */
    openPopup(index) {
      this.indexToRemove = index;
      this.showPopup = true;
    },
    /**
     *  Close the address remove popup
     */
    closePopup() {
      this.showPopup = false;
    },
    /**
     *  Show the suggest address popup
     */
    presentSuggestedAddressModal(suggestAddress) {
      this.suggestedAddress = suggestAddress;
      this.isSuggestedAddressModalVisible = true;
      oneUtils.utils.hideGlobalLoader();
    },
    /**
     *  Hide the suggest address popup
     */
    dismissSuggestedAddressModal() {
      this.isSuggestedAddressModalVisible = false;
      this.suggestAddress = {};
      this.handleEditMode(null);
    },
    /**
     *  Get address value from the suggested address object
     */
    prepareCurrentAddress(currentAddress, country, companyName){
      if(typeof this.suggestedAddress.street != 'undefined') currentAddress.street = this.suggestedAddress.street;
      if(typeof this.suggestedAddress.houseNumber != 'undefined') currentAddress.houseNumber = this.suggestedAddress.houseNumber;
      if(typeof this.suggestedAddress.postalCode != 'undefined') currentAddress.postalCode = this.suggestedAddress.postalCode;
      if(typeof this.suggestedAddress.city != 'undefined') currentAddress.city = this.suggestedAddress.city;
      if(typeof this.suggestedAddress.strSuppl1 != 'undefined') currentAddress.strSuppl1 = this.suggestedAddress.strSuppl1;
      if(typeof this.suggestedAddress.strSuppl2 != 'undefined') currentAddress.strSuppl2 = this.suggestedAddress.strSuppl2;
      if(typeof this.suggestedAddress.regionCode != 'undefined') currentAddress.regionCode = this.suggestedAddress.regionCode;
      currentAddress.country = country ? country.key : null;
      if(typeof this.form.type != 'undefined') currentAddress.addressStatus = this.form.type;
      if(typeof this.form.preferred != 'undefined') currentAddress.preferred = this.form.preferred;
      if(typeof companyName != 'undefined')currentAddress.companyName = companyName;
    },
    /**
     *  Get address value
     */
    prepareCurrentAddressFromForm(currentAddress, country, companyName){
      if(typeof this.form.street != 'undefined') currentAddress.street = this.form.street;
      if(typeof this.form.houseNumber != 'undefined') currentAddress.houseNumber = this.form.houseNumber;
      if(typeof this.form.postalCode != 'undefined') currentAddress.postalCode = this.form.postalCode;
      if(typeof this.form.city != 'undefined') currentAddress.city = this.form.city;
      if(typeof this.form.strSuppl1 != 'undefined') currentAddress.strSuppl1 = this.form.strSuppl1;
      if(typeof this.form.strSuppl2 != 'undefined') currentAddress.strSuppl2 = this.form.strSuppl2;
      if(typeof this.form.regionCode != 'undefined') currentAddress.regionCode = this.form.regionCode;
      currentAddress.country = country ? country.key : null;
      if(typeof this.form.type != 'undefined') currentAddress.addressStatus = this.form.type;
      if(typeof this.form.preferred != 'undefined') currentAddress.preferred = this.form.preferred;
      if(typeof companyName != 'undefined') currentAddress.companyName = companyName;
    },

    /**
     *  Apply or discard address suggestion
    */
    addressSuggestionManagement(suggestApproved) {
      let currentAddress = this.user.addresses[this.editMode];
      const country = this.$c("list_of_countries").find(( country ) => country.key === this.form.country);
      const companyName = this.form.type!="BUSINESS" ? undefined : this.form.companyName;

        if (!currentAddress) {
            const newAddress = this.newAddressValorization(suggestApproved, country, companyName);
            this.user.addresses.push(newAddress);
        } else {
          if (suggestApproved) {
                currentAddress = this.prepareCurrentAddress(currentAddress,country, companyName);
          } else {
                currentAddress = this.prepareCurrentAddressFromForm(currentAddress, country, companyName);
          }
        }
        this.setPreferredIfMissing();
        this.dismissSuggestedAddressModal();
    },

      /**
       *  valorizing address with suggested value or with form value
      */
      newAddressValorization(suggestApproved, country, companyName) {
          return {
              "street": suggestApproved ? this.suggestedAddress.street : this.form.street,
              "houseNumber": suggestApproved ? this.suggestedAddress.houseNumber: this.form.houseNumber,
              "postalCode": suggestApproved ? this.suggestedAddress.postalCode : this.form.postalCode,
              "city": suggestApproved ? this.suggestedAddress.city : this.form.city,
              "strSuppl1": suggestApproved ? this.suggestedAddress.strSuppl1: this.form.strSuppl1,
              "strSuppl2": suggestApproved ? this.suggestedAddress.strSuppl2: this.form.strSuppl2,
              "regionCode": suggestApproved ? this.suggestedAddress.regionCode: this.form.regionCode,
              "country": country ? country.key : null,
              "addressStatus": this.form.type,
              "preferred": this.form.preferred,
              "companyName": companyName
            };
      },

    /**
     *  Form valorization
    */
    prefillForm: function (key) {
      if (this.user.addresses && this.typeKeys.includes(this.user.addresses[key].addressStatus)) {
        this.form.type=this.user.addresses[key].addressStatus;
        this.touchForm("type");
      }
      if (this.user.addresses && this.selectedOptions.some(c => c.value === this.user.addresses[key].country)) {
        const country = this.selectedOptions.find(c => c.value === this.user.addresses[key].country);
        this.form.country = country.value;
        this.touchForm("country");
      }

      this.form.street = this.user.addresses[key].street;
      this.touchForm("street");
      this.form.houseNumber = this.user.addresses[key].houseNumber;
      this.touchForm("houseNumber");
      this.form.postalCode = this.user.addresses[key].postalCode;
      this.touchForm("postalCode");
      this.form.city = this.user.addresses[key].city;
      this.touchForm("city");
      this.form.strSuppl1 = this.user.addresses[key].strSuppl1;
      this.touchForm("strSuppl1");
      this.form.strSuppl2 = this.user.addresses[key].strSuppl2;
      this.touchForm("strSuppl2");
      this.form.regionCode = this.user.addresses[key].regionCode;
      this.touchForm("regionCode");
      this.form.preferred = this.user.addresses[key].preferred;
      this.touchForm("preferred");
      this.form.companyName = this.user.addresses[key].companyName;
      this.touchForm("preferred");

    },

    /**
     *  Form submit
    */
    validateAddress() {
      this.submitUpdate();
    },

    /**
     *  Form submit
    */
    getSuggestAddress(address) {
      return oneUtils.httpClient.suggestAddress(address, oneUtils.enums.tolerantProfileKey.INTERACTIVE, this.sectionConfig);
    },

    /**
     *  Address valorization with edited address
    */
    prepareEditAddress(oldAddress, country){
      if(typeof this.form.street != 'undefined') oldAddress.street = this.form.street;
      if(typeof this.form.houseNumber != 'undefined') oldAddress.houseNumber = this.form.houseNumber;
      if(typeof this.form.postalCode != 'undefined') oldAddress.postalCode = this.form.postalCode;
      if(typeof this.form.city != 'undefined') oldAddress.city = this.form.city;
      if(typeof this.form.strSuppl1 != 'undefined') oldAddress.strSuppl1 = this.form.strSuppl1;
      if(typeof this.form.preferred != 'undefined') oldAddress.preferred = this.form.preferred;
      if(typeof this.form.strSuppl2 != 'undefined') oldAddress.strSuppl2 = this.form.strSuppl2;
      if(typeof this.form.regionCode != 'undefined') oldAddress.regionCode = this.form.regionCode;
      if(typeof this.form.type != 'undefined') oldAddress.addressStatus = this.form.type;
      if(typeof this.form.companyName != 'undefined') oldAddress.companyName = this.form.type!="BUSINESS" ? '' : this.form.companyName;
      if(typeof this.form.country != 'undefined') oldAddress.country = country ? country.value : '';
      return oldAddress;
    },
    

    /**
     *  Edit management
     *  Tolerant control
    */
    async manageEdit(country){
      if(this.form.preferred){
        for (const address of this.user.addresses) {
          address.preferred = false;
        }
      }

      // tolerant flow - start
      const newAddress = this.form;
      newAddress.country = country ? country.value : null;

      if(!this.isRegionCodeVisible(newAddress.country)) {
        newAddress.regionCode = null;
      }

      const tolerantEnabled = this.$c('enable_tolerant_interactive');
      if (tolerantEnabled) {
        const suggestAddress = await this.getSuggestAddress(newAddress);
        if (suggestAddress) {
          this.presentSuggestedAddressModal(suggestAddress);
          return;
        }
      }
      // tolerant flow - end

      let oldAddress = this.user.addresses[this.editMode];
      oldAddress = this.prepareEditAddress(oldAddress, country);
      this.setPreferredIfMissing();
      this.handleEditMode(null);
    },

    /**
     *  Add management
     *  Tracy tracking: address added with + type + preferred
     *  Tolerant control
    */
    async manageAdd(country){
      if(this.form.preferred){
        for (const address of this.user.addresses) {
          address.preferred = false;
        }
      }


      const newAddress = {
        "street": this.form.street,
        "houseNumber": this.form.houseNumber,
        "postalCode": this.form.postalCode,
        "city": this.form.city,
        "strSuppl1": this.form.strSuppl1,
        "preferred": this.form.preferred,
        "strSuppl2": this.form.strSuppl2,
        "regionCode": this.form.regionCode,
        "addressStatus": this.form.type,
        "country": country ? country.value : null,
      };

      // tolerant flow - start
      const tolerantEnabled = this.$c('enable_tolerant_interactive');
      if (tolerantEnabled) {
        const suggestAddress = await this.getSuggestAddress(newAddress);
        if (suggestAddress) {
          this.presentSuggestedAddressModal(suggestAddress);
          return;
        }
      }
      if(this.form.type=="BUSINESS"){
        newAddress['companyName'] = this.form.companyName;
      }
      // tolerant flow - end
      this.user.addresses.push(newAddress);
      this.handleEditMode(null);
    },


    /**
     * Remove management
     */

    manageRemove(){
      // If the address to be deleted is the original user address
      if(this.$store.getters.getOriginalUser.addresses && this.$store.getters.getOriginalUser.addresses[this.indexToRemove]){

        this.user.addresses[this.indexToRemove]['delete']=true;

        // //needed for watch
        if(this.user.addresses[this.indexToRemove]['street']){
          const street = JSON.parse(JSON.stringify(this.user.addresses[this.indexToRemove]['street']));
          this.user.addresses[this.indexToRemove]['street']="";
          this.user.addresses[this.indexToRemove]['street']=street;
        }
        if(this.user.addresses[this.indexToRemove]['addressStatus']){
          const addressStatus = JSON.parse(JSON.stringify(this.user.addresses[this.indexToRemove]['addressStatus']));
          this.user.addresses[this.indexToRemove]['addressStatus']="";
          this.user.addresses[this.indexToRemove]['addressStatus']=addressStatus;
        }
      } else{
        this.user.addresses.splice(this.indexToRemove, 1);
      }
      this.setPreferredIfMissing(); 
    },

    setPreferredIfMissing(){
      //if not preferred, set to first
      if (this.user.addresses.filter(address=>!address.delete && address.preferred).length === 0) {
        if (this.user.addresses.filter(address=>!address.delete).length>0){
          this.user.addresses.filter(address=>!address.delete)[0].preferred=true;
        }
      }

    },


    /**
     * Form submit management for add, edit or delete address
     */

    async submitUpdate() {
      oneUtils.utils.showGlobalLoader();
      if(!this.user.addresses){
        this.user.addresses = [];
      }
      const country = this.selectedOptions.find(c => c.value === this.form.country);
      if (this.user.addresses[this.editMode]){
        //edit
        await this.manageEdit(country);
      } else if(this.editMode==-1){
        //add
        await this.manageAdd(country);
      }else{
        //remove
        this.manageRemove();
      }

      oneUtils.utils.hideGlobalLoader();
    },

    displayUserAddressData(userAddress, fieldName) {
      if(!this.getDisplayTogether(userAddress.country)) return fieldName === "country" ? this.countryLabel(userAddress[fieldName]) : userAddress[fieldName];

      for (const [key, fieldList] of Object.entries(this.getDisplayTogether(userAddress.country))) {
        if(key === fieldName) {
          let dataToReturnAsArray = [];
          dataToReturnAsArray.push({
            fieldName: fieldName === "country" ? this.countryLabel(userAddress[fieldName]) : userAddress[fieldName],
            order: 0
          });

          for (const [fieldKey, config] of Object.entries(fieldList)) { 
            if(userAddress[fieldKey] && config.display) {
              dataToReturnAsArray.push({
                fieldName: (fieldKey === "country" ? this.countryLabel(userAddress[fieldKey]) : userAddress[fieldKey]),
                order: config.order
              });
            }
          }
      
          return dataToReturnAsArray.sort((a, b) => {
            return a.order < b.order;
          }).map((arr) => {
            return arr.fieldName;
          }).join(" ");
        } else if (fieldList[fieldName] && fieldList[fieldName].display) {
          return "";
        }
      }
      return fieldName === "country" ? this.countryLabel(userAddress[fieldName]) : userAddress[fieldName];
    },

    isUserAddressDataToDisplay(userAddress, fieldName) {
      if(!userAddress[fieldName]) return false;

      if(fieldName === "regionCode") {
        return this.isRegionCodeVisible(userAddress.country);
      }

      if(!this.getDisplayTogether(userAddress.country)) return true;

      for (const [key, fieldList] of Object.entries(this.getDisplayTogether(userAddress.country))) {
        if(key === fieldName) {
          for(const [_, innerFieldConfig] of Object.entries(fieldList)) {
            if(!innerFieldConfig.display) return false;
          }
          return true;
        } else if (fieldList[fieldName] && fieldList[fieldName].display) {
          return false;
        }
      }
      return true;
    },

    getDisplayTogether(country) {
      if (this.sectionConfig.addressesSectionByCountrySelection &&
        this.sectionConfig.addressesSectionByCountrySelection[country]) {
          return this.sectionConfig.addressesSectionByCountrySelection[country].displayTogether;
      }
      return this.sectionConfig.displayTogether;
    },
  },
});
</script>
